import React from 'react';
import { Button, Table } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import product from '../../../../shared/data/product.json';
import Empty from '../../../../shared/components/Empty/Index';

import './styles.css';

export default function Items(props) {
    return (
        <Table
            rowKey="id"
            size='small'
            dataSource={product}
            locale={{ emptyText: <Empty /> }}
            pagination={{
                showSizeChanger: false,
                showTotal: (total) => `${total} Registro(s) encontrado(s).`
            }}
            columns={[
                {
                    title: '',
                    align: 'center',
                    width: 60,
                    render: (item) => {
                        return (
                            <div className='inline-flex'>
                                <Button
                                    style={{ padding: '0px 6px', height: 'auto' }}
                                    onClick={() => props.onEdit(item)}>
                                    <EditOutlined />
                                </Button>
                            </div>
                        );
                    }
                },
                {
                    title: 'Nombre',
                    key: 'name',
                    dataIndex: 'name'
                },
                {
                    title: 'Marca',
                    key: 'brandName',
                    dataIndex: 'brandName'
                },
                {
                    title: 'Precio',
                    width: 130,
                    align: 'right',
                    key: 'price',
                    render: (item) => (item.price.toFixed(2))
                },
                {
                    title: 'Color',
                    key: 'color',
                    dataIndex: 'color'
                }
            ]}
        />
    );
}